<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { cn } from '@/utils/cn'
import { SidebarMenuItem as UiSidebarMenuItem } from '@/components/ui/sidebar'
import type { NavItem } from './types'

const props = defineProps<{ nav: NavItem; showContent: boolean }>()

const route = useRoute()
const isActive = computed(() => route.name === props.nav.to.name)
</script>

<template>
  <UiSidebarMenuItem>
    <RouterLink
      :to="props.nav.to"
      :title="props.nav.name"
      :aria-label="props.nav.name"
      :class="cn(
        'group menu-item',
        isActive ? 'menu-item-active' : 'menu-item-inactive',
        !props.showContent && 'justify-center',
      )"
    >
      <span :class="isActive ? 'menu-item-icon-active' : 'menu-item-icon-inactive'">
        <component :is="props.nav.icon" class="size-6 stroke-[1.5px]" aria-hidden="true" />
      </span>
      <span v-if="props.showContent" class="menu-item-text">{{ props.nav.name }}</span>
    </RouterLink>
  </UiSidebarMenuItem>
</template>
